import * as yup from 'yup'
import yupValidation from '../../../lib/yupValidation'

const isFilled = (valorInicial, valorFinal) => valorInicial || valorFinal
const isChecked = arr => !!arr.filter(value => value === true).length

const form = yup.object().shape({
  descricao: yup
    .string()
    .trim()
    .required('Obrigatório'),
  valorInicial: yup
    .number()
    .nullable()
    .test(
      'test-valores',
      'Obrigatório o preenchimento de alguma faixa de valores',
      (value, context) => {
        const valorInicial = value
        const valorFinal = context.parent.valorFinal

        return isFilled(valorInicial, valorFinal)
      }
    )
    .nullable(),
  valorFinal: yup.number().nullable(),
  riscoId: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  limiteValorKmm: yup.number().required('Obrigatório'),
  prazoRenovacao: yup
    .string()
    .test('teste-prazo-renovacao', 'A quantidade deve ser em dias', value => {
      if (value && !isNaN(value)) {
        const valueFormatted = typeof value === 'string' ? Number(value) : value

        return valueFormatted > -1 && Number.isInteger(valueFormatted)
      }

      return false
    })
    .required('Obrigatório'),
  autonomiaAuxiliar: yup
    .boolean()
    .test(
      'test-tipo-liberacao',
      'Obrigatório algum tipo de Autonomia',
      (value, context) => {
        const autonomiaAuxiliar = value

        const autonomiaAssistente = context.parent.autonomiaAssistente
        const autonomiaAdministrador = context.parent.autonomiaAdministrador

        return isChecked([
          autonomiaAuxiliar,
          autonomiaAssistente,
          autonomiaAdministrador
        ])
      }
    ),
  autonomiaAssistente: yup.boolean(),
  autonomiaAdministrador: yup.boolean(),
  liberadoAutomacao: yup
    .boolean()
    .test(
      'test-tipo-liberacao',
      'Obrigatório algum tipo de Liberação',
      (value, context) => {
        const liberadoAutomacao = value

        const liberadoCentralCadastros = context.parent.liberadoCentralCadastros
        const liberadoGestor = context.parent.liberadoGestor

        return isChecked([
          liberadoAutomacao,
          liberadoCentralCadastros,
          liberadoGestor
        ])
      }
    ),
  liberadoCentralCadastros: yup.boolean(),
  liberadoGestor: yup.boolean()
})

export const validateForm = yupValidation(form)
